/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit'
import { LegalWritingStatus, LegalWritingType } from 'src/enums/EscritosLegales'
import {
  setLegalWritingStatusAction,
  setLegalWritingTypeAction,
  addFormValidatorFieldAction,
  removeFormValidatorFieldAction,
  addFormValidatorValueAction,
  removeFormValidatorValueAction,
  addFormValidatorErrorAction,
  removeFormValidatorErrorAction,
  clearFormValidatorErrorsAction
} from './actions'

interface FormValidatorValue {
  [index: string]: unknown
}

interface State {
  status: LegalWritingStatus
  type: LegalWritingType
  formValidatorFields: any[]
  formValidatorValues: FormValidatorValue
  formValidatorErrors: FormValidatorValue
}

const initialState: State = {
  status: LegalWritingStatus.SELECTION,
  type: LegalWritingType.NO_DEFINIDO,
  formValidatorFields: [],
  formValidatorValues: {},
  formValidatorErrors: {}
}

export default createReducer(initialState, {
  [setLegalWritingStatusAction.type]: (state, action) => {
    state.status = action.payload
  },
  [setLegalWritingTypeAction.type]: (state, action) => {
    state.type = action.payload
  },
  [addFormValidatorFieldAction.type]: (state, action) => {
    state.formValidatorFields.push(action.payload)
  },
  [removeFormValidatorFieldAction.type]: (state, action) => {
    state.formValidatorFields = state.formValidatorFields.filter(
      (field: any) => field.name !== action.payload
    )
  },
  [addFormValidatorValueAction.type]: (state, action) => {
    state.formValidatorValues[action.payload.name] = action.payload.value
  },
  [removeFormValidatorValueAction.type]: (state, action) => {
    delete state.formValidatorValues[action.payload]
  },
  [addFormValidatorErrorAction.type]: (state, action) => {
    state.formValidatorErrors[action.payload.name] = {
      value: action.payload.value,
      type: action.payload.type
    }
  },
  [removeFormValidatorErrorAction.type]: (state, action) => {
    delete state.formValidatorErrors[action.payload]
  },
  [clearFormValidatorErrorsAction.type]: state => {
    state.formValidatorErrors = {}
  }
})
